import { store } from '@betacrew/jars-flux';
import { all, put, takeLatest } from 'redux-saga/effects';

import { componentKey, setLoadingState, setShowAddAttachmentPopup, setUploadedFile, setUploadedFileData } from './FormAttachmentUploadSlice';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { PAGE_STATE } from '../../constants/constants';
import BoiDataService from '../../../../services/BoiDataService';
import CommonDataService from '../../../../services/CommonDataService';

export const { saveAttachment } = {
    saveAttachment: (payload) => {
        return {
            type: "FORM_ATTACHMENT/SAVE",
            payload: payload
        }
    },
}

function* saveAttachmentAsync(action) {
    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING }));
        const { uploadedFile, source, commonBase } = action.payload;
        const formData = new FormData();
        formData.append("files", uploadedFile);

        const response = yield CommonDataService.uploadAttachment(source, formData, commonBase);
        if (response?.data.Status === 1) {
            yield put(addNotifications({
                heading: "Success",
                message: response?.data?.Message ?? "",
                variant: TOASTER_VARIANT.SUCCESS,
            }));
            yield put(setUploadedFileData({source: source, FileName: uploadedFile?.name ?? "", FilePath: response?.data?.Data ?? ""}))
            yield put(setShowAddAttachmentPopup(false));
            yield put(setUploadedFile(null));
        }
    } catch {
        yield put(addNotifications({
            heading: "Error",
            message: "Invalid request. Please try again.",
        }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }));
    }
}

function* rootSaga() {
    yield all([
        takeLatest(saveAttachment().type, saveAttachmentAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);